import { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/AuthContext';
import { joinLeague } from '../../services/leagueApi';
import LeagueBadge from './LeagueBadge';

const ALL_TIERS = ['bronze', 'silver', 'gold', 'platinum', 'diamond'];

function LeagueJoinCard({ onJoined }) {
  const { user } = useContext(AuthContext);
  const [joining, setJoining] = useState(false);
  const [error, setError] = useState(null);

  const handleJoin = async () => {
    setJoining(true);
    setError(null);
    try {
      await joinLeague();
      if (onJoined) onJoined();
    } catch (err) {
      setError(err.message);
    } finally {
      setJoining(false);
    }
  };

  return (
    <div className="bg-puzzle-background rounded-xl p-6 text-center max-w-lg mx-auto">
      <h2 className="text-2xl font-bold text-puzzle-text mb-3">Join Leagues</h2>
      <p className="text-puzzle-text-secondary mb-4">
        Compete in ranked divisions! Earn rating points from daily puzzles,
        climb through tiers, and get promoted every two weeks.
      </p>

      <div className="flex justify-center gap-3 mb-6">
        {ALL_TIERS.map((tier) => (
          <LeagueBadge key={tier} tier={tier} size="md" showLabel={false} />
        ))}
      </div>

      <div className="text-sm text-puzzle-text-secondary mb-6 space-y-1">
        <p>Complete daily puzzles to earn rating points</p>
        <p>Top 20% get promoted every two weeks</p>
        <p>Bottom 20% get relegated</p>
      </div>

      {!user ? (
        <Link
          to="/login"
          className="inline-block px-6 py-2.5 bg-puzzle-blue text-white rounded-lg font-medium hover:opacity-90 transition-opacity"
        >
          Sign in to join
        </Link>
      ) : (
        <>
          <button
            type="button"
            onClick={handleJoin}
            disabled={joining}
            className="px-6 py-2.5 bg-puzzle-blue text-white rounded-lg font-medium hover:opacity-90 transition-opacity disabled:opacity-50"
          >
            {joining ? 'Joining...' : 'Join Leagues'}
          </button>
          {error && <p className="mt-2 text-sm text-red-500">{error}</p>}
        </>
      )}

      <p className="mt-4 text-xs text-puzzle-text-secondary">
        Everyone starts in Bronze.
        {' '}
        <Link to="/how-it-works#leagues" className="text-puzzle-blue hover:underline">
          Learn how scoring works
        </Link>
      </p>
    </div>
  );
}

LeagueJoinCard.propTypes = {
  onJoined: PropTypes.func,
};

LeagueJoinCard.defaultProps = {
  onJoined: null,
};

export default LeagueJoinCard;
